// extracted by mini-css-extract-plugin
module.exports = {"QueryUser":"QueryUser_QueryUser__LDwpz","mainContainer":"QueryUser_mainContainer__3xlRR"};